/**
 * Shared UI strings, and the copy standard they exist to enforce.
 *
 * THE STANDARD, in the order a reader meets the words on screen:
 *
 *   1. Card / section title — Sentence case, no trailing punctuation. "Outbound
 *      correction", not "Outbound Correction". Title Case was used on roughly half
 *      the app and Sentence case on the other half, split by when each card was
 *      written rather than by any rule.
 *
 *   2. Subtitle — ONE line, under ~60 characters, and it says what the number IS.
 *      No caveats, no retention windows, no "expect this to differ because…".
 *      It renders uppercase and letter-spaced, which is unreadable past one line.
 *
 *   3. Caveats go in an InfoTip, capped at ~400 characters. Structure it as: what
 *      this is, when you would touch it, the one thing that will surprise you.
 *      Anything longer is documentation and belongs in the repo, not in a panel
 *      that covers the data behind it.
 *
 *   4. Never say it twice. Four pages carried an InfoTip AND a paragraph under the
 *      heading restating it. The paragraph loses.
 *
 *   5. NEVER put prose in a native `title=` attribute. It is invisible to touch
 *      users and to anyone navigating by keyboard, it cannot be dismissed, and it
 *      disappears on the smallest pointer movement. `components/InfoTip.jsx`
 *      documents this at length and is the supported route. `title=` remains fine
 *      for a bare truncated value ("the full string this cell elides").
 *
 *   6. One vocabulary. `agent` for the per-user runtime, never "container" or
 *      "runtime" in user-facing text. One name per identifier. `tools`, never
 *      "skills" or "services".
 *
 *   7. Buttons say the verb: `Save`, `Delete <object>`, `Cancel` to abandon an
 *      edit, `Close` only to dismiss something read-only.
 *
 * `tests/test_frontend_copy_standard.py` enforces 3, 5 and the ellipsis below.
 * The rest is judgement and lives here so there is one place to argue with.
 */

// One phrasing for "the query worked and there is nothing to show". The app
// previously shipped `No data yet`, `No events yet` and `Nothing detected yet`
// on a single page, which reads as three different conditions.
export const EMPTY_TEXT = 'No data yet';

// U+2026, not three periods. Both spellings were in use, roughly half and half.
export const LOADING_TEXT = 'Loading…';

// Cap the standard puts on an InfoTip body. Exported so the test and the prose
// above cannot disagree about the number.
export const INFOTIP_MAX_CHARS = 400;
